import { axios } from 'api'
import { useCommonEntryContext } from 'components_v2/common'
import MyPracticeDataLoader from 'components_v2/MyPractice'
import { useUserContext } from 'context'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Main = styled.div``
const MyPracticeView = () => {
  const { searchParams, setGlobalState, globalState } = useCommonEntryContext()
  const MyPracticeData = globalState?.my_practice_data
  const [props, setProps] = useState(null)
  const { user } = useUserContext()

  const tab = searchParams?.get('tab') || 'classes'

  useEffect(() => {
    if (MyPracticeData) {
      setProps(MyPracticeData)
      return
    }
    axios
      .get('/my_practice/page_data', { load: true })
      .then((res) => {
        setProps(res.data)
        setGlobalState('my_practice_data', res.data)
      })
      .catch((err) => console.log(err))
  }, [MyPracticeData, setGlobalState])
  if (!props) return null
  return (
    <Main>
      <MyPracticeDataLoader
        username={user.username}
        selected_tab={tab}
        user={user}
        {...props}
      />
    </Main>
  )
}

export default MyPracticeView
